import { Alert, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { submitApproval } from '../../../../store/startup/approval/approvalSlice';

export default function Approval() {
    const dispatch = useDispatch();
    const { startupId } = useParams();
    const { loading } = useSelector((state) => state.approval);

    const handleSubmit = () => {
        dispatch(submitApproval(startupId));
    };

    return (
        <div>
            <Alert severity="warning" sx={{ mt: 4 }}>
                Başvurunuz incelenmek üzere admin onayına gönderilecektir. Bu süreç birkaç gün sürebilir.
            </Alert>
            <Button 
                variant="contained" 
                sx={{ mt: 3 }}
                onClick={handleSubmit}
                disabled={loading}
            >
                {loading ? 'Gönderiliyor...' : 'Başvuruyu Gönder'}
            </Button>
        </div>
    );
}